document.addEventListener("DOMContentLoaded", (event) => {
  if(document.querySelectorAll('.ftr-newsltr-btn')) document.querySelectorAll('.ftr-newsltr-btn').forEach(function(newsltrButton){
    newsltrButton.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelector('body').classList.toggle('open-newsltr');
      if(document.querySelector('body').classList.contains('open-newsltr')){
        document.querySelector('.newsltr-popup').style.maxHeight = document.querySelector('.newsltr-popup-wrap').offsetHeight+'px';
      }else{
        document.querySelector('.newsltr-popup').style.maxHeight = '';
      }
      document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    });
  });
  if(document.querySelector('.newsltr-popup-close')) document.querySelector('.newsltr-popup-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.newsltr-popup').style.maxHeight = '';
    document.querySelector('body').classList.remove('open-newsltr');
  })
})
document.addEventListener("DOMContentLoaded", function() {
  let urlParams = new URLSearchParams(window.location.search);
  if(window.location.hash != '' || window.location.href.includes('customer') & window.location.href.includes('customer-order') == false){
    if(window.location.href.includes('challenge') == false || window.location.href.includes('form_type=customer') || window.location.href.includes('?customer_posted=true') && window.location.hash === '#ContactFooter'){
      document.querySelector('.newsltr-popup').style.maxHeight = document.querySelector('.newsltr-popup-wrap').offsetHeight+'px';
      document.querySelector('body').classList.add('open-newsltr');
    }
  }
});
